exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#photo-gallery[data-v-55171cd8]{margin-top:152px;scroll-margin-top:152px}", ""]);

// exports
